var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#5C5560"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2899 10.4481H12.7411V14.7927H18.6135C18.0849 16.2034 17.0814 17.3819 15.7974 18.135C14.8301 18.7028 13.7029 19.028 12.4997 19.028C9.70049 19.028 7.31274 17.266 6.3853 14.7908C6.11738 14.0782 5.97139 13.3058 5.97139 12.4997C5.97139 11.7568 6.09565 11.043 6.32378 10.3781C7.20474 7.81416 9.63716 5.97134 12.4997 5.97134C13.7675 5.97134 14.9508 6.33276 15.9519 6.95854L19.5096 4.04585C17.6076 2.46675 15.1644 1.51758 12.4997 1.51758C8.25532 1.51758 4.57329 3.9252 2.74551 7.44917C1.96045 8.96128 1.51758 10.6786 1.51758 12.4997C1.51758 14.383 1.99126 16.1552 2.82642 17.7042C4.6813 21.1442 8.31748 23.4818 12.4997 23.4818C15.1022 23.4818 17.493 22.5768 19.375 21.064C21.3102 19.5084 22.707 17.3102 23.2417 14.7927C23.3992 14.0529 23.4818 13.2859 23.4818 12.4997C23.4818 11.7985 23.4161 11.1125 23.2899 10.4481Z",
    fill: "#FBBB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3747 21.0635L19.3753 21.0642C17.4932 22.5769 15.1025 23.482 12.5 23.482C8.31773 23.482 4.68154 21.1444 2.82666 17.7043L6.3856 14.791C7.31304 17.2662 9.70073 19.0282 12.5 19.0282C13.7032 19.0282 14.8304 18.703 15.7977 18.1352L19.3747 21.0635Z",
    fill: "#28B446"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2901 10.4482C23.4182 11.1246 23.4824 11.8115 23.482 12.4999C23.482 13.2861 23.3994 14.053 23.2419 14.7928C22.7073 17.3103 21.3104 19.5085 19.3752 21.0641L19.3746 21.0635L15.7975 18.1351C17.0816 17.382 18.0851 16.2036 18.6136 14.7928H12.7412V10.4482H18.6994H23.2901Z",
    fill: "#518EF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5102 4.0459L15.9524 6.95859C14.9514 6.33281 13.7681 5.97139 12.5003 5.97139C9.63769 5.97139 7.20532 7.81421 6.32437 10.3781L2.74673 7.44917H2.74609C4.57388 3.9252 8.25586 1.51758 12.5003 1.51758C15.165 1.51758 17.6082 2.46675 19.5102 4.0459Z",
    fill: "#FC3F1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.bcea7809576673a7aa77242ada8de232.svg";
export { ForwardRef as ReactComponent };